import { useEffect } from 'react'

export function useSpacingSubotStickyBar() {
  useEffect(() => {
    /** This class is used on Subot Iframe to avoid overlapping the UI at the bottom */
    document.body.classList.add('hhg-has-sticky-bar')
    return () => {
      document.body.classList.remove('hhg-has-sticky-bar')
    }
  }, [])
}
